import { SubCategory } from "@robe/core-types";
import { XcoreCore } from "XcoreCore";
import { BaseApiRequest } from "../baseApiRequest";

export const reorderSubCategories = (
  type: string,
  order: number[] | Record<string, number>,
  core: XcoreCore
): BaseApiRequest<SubCategory[]> =>
  core
    .fetch(`/api/category/toplevel/${type}/reorder`, {
      ...core.getCtx,
      method: "PUT",
      body: JSON.stringify(Array.isArray(order) ? Object.fromEntries(order.map((v, i) => [v, i])) : order),
    })
    .then((res) => res.json());
